import type { ZodSchema } from 'zod'
import { zodToJsonSchema } from 'zod-to-json-schema'
import { utils } from '@bond/utils'

export function generateFieldConstraints(
  schema?: ZodSchema,
  fieldName?: string,
) {
  if (!schema || !fieldName) {
    return {}
  }

  const jsonSchema = zodToJsonSchema(schema)

  if ('properties' in jsonSchema && fieldName in jsonSchema.properties) {
    const fieldProperties = jsonSchema.properties[fieldName]

    const minlength =
      fieldProperties &&
      'minLength' in fieldProperties &&
      fieldProperties.minLength

    const maxlength =
      fieldProperties &&
      'maxLength' in fieldProperties &&
      fieldProperties.maxLength

    const required = jsonSchema.required?.includes(fieldName)

    return utils.object.filterObjectValues(
      { minlength, maxlength, required },
      (value) => value !== undefined,
    )
  }
  return {}
}
